// new with selection moved upwards

/*  src/App.js  */
import React, { useState, useContext, useRef, useEffect } from 'react';
import {
  CssBaseline, Box, TextField, IconButton, Typography, Button, Avatar, Autocomplete,
  AppBar, Toolbar, Paper, Snackbar, Alert, Badge, Tooltip, Drawer,
  List, ListItem, ListItemText, ListItemIcon, ListItemButton,
  useMediaQuery, Dialog, DialogTitle, DialogContent, DialogActions,
  Modal
} from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import ReactMarkdown from 'react-markdown'; 
import remarkGfm from 'remark-gfm';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
// import iQuestLogo from '../pages/images/iQuestLogo.png';
// UIupdate
import livaLogo from "../pages/images/livaLogo.png"
import product_default_q from '../data/product_default_q.json'
// import product_questionaire from '../data/product_questionaire.json'
/* ─── icons ────────────────────────────────────────────── */
import SendIcon from '@mui/icons-material/Send';
import ThumbUpSharp from '@mui/icons-material/ThumbUpSharp'
import ThumbDownAltOutlined from '@mui/icons-material/ThumbDownAltOutlined'
import ThumbUpAltOutlined from '@mui/icons-material/ThumbUpAltOutlined'

// import SmartToyIcon from '@mui/icons-material/SmartToy';
import ViewInArOutlinedIcon from '@mui/icons-material/ViewInArOutlined';

import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';

import PublicIcon from '@mui/icons-material/Public';
import GroupsIcon from '@mui/icons-material/Groups';
import SecurityIcon from '@mui/icons-material/Security';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MenuIcon from '@mui/icons-material/Menu';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import FeedbackIcon from '@mui/icons-material/Feedback';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpAltOutlined';
import ThumbDownIcon from '@mui/icons-material/ThumbDownAltOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ReplayIcon from '@mui/icons-material/Replay';
import CloseIcon from '@mui/icons-material/Close';

import { useTheme } from '@mui/material/styles';

 

import apiClient from '../utils/apiClient';
import { UserContext } from '../context/UserContext';
// import LoginPage from './pages/LoginPage';
/* ─── sample data ──────────────────────────────────────── */
import chatbotMapping from '../data/chatbot_product_card_con.json';
import productFrontend from '../data/product_frontend.json';
import { useNavigate } from 'react-router-dom';

import chatbotIcon from "./images/chatbotIcon.jpg"

// import chatbotIcon from "./images/IMG_3821.jpeg"


/* ─── brand theme (unchanged) ──────────────────────────── */
const theme = createTheme({
  palette: {
    // UIupdate
    primary: { main: '#C65A4A', light: '#3371AC', dark: '#003366', contrastText: '#fff' },
    // primary: { main: 'rgb(112 48 160)', light: '#3371AC', dark: '#003366', contrastText: '#fff' },
    secondary: { main: '#FF7519', light: '#FF9649', dark: '#D15700', contrastText: '#fff' },
    background: { default: '#F7E9E5', paper: '#fff' }
  },
  typography: { fontFamily: '"Montserrat","Roboto","Helvetica","Arial",sans-serif' },
  shape: { borderRadius: 8 },
  components: { MuiButton: { styleOverrides: { root: { textTransform: 'none', fontWeight: 600 } } } }
});
/* ─── global scrollbars (unchanged) ───────────────────── */
const GlobalStyles = () => (
  <style>{`
    ::-webkit-scrollbar{width:6px;height:6px}
    ::-webkit-scrollbar-track{background:transparent}
    ::-webkit-scrollbar-thumb{background:rgba(0,0,0,.15);border-radius:4px}
    ::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,.3)}
    body,#root{margin:0;height:100vh;overflow:hidden}
  `}</style>
);
/* ─ meta for each assistant ─ */
const botMeta = {
  product: { icon: <ViewInArOutlinedIcon fontSize="small" />, color: theme.palette.primary.main, label: 'Product Assistant' },
  nri: { icon: <PublicIcon fontSize="small" />, color: '#2E7D32', label: 'NRI Assistant' },
  lifeai: { icon: <GroupsIcon fontSize="small" />, color: '#9C27B0', label: 'LIFE-AI Team' },
  uw: { icon: <SecurityIcon fontSize="small" />, color: '#D32F2F', label: 'Underwriter Assistant' },
  customer: { icon: <SupportAgentOutlinedIcon fontSize="small" />, color: '#1976D2', label: 'Customer Query' }
};

// customer query categories
const customerCategories = [
 "Surrender",
 "Payout related",
 "Issuance related",
 "Refund cancellation",
 "Customer info update",
 "Premium frequency change",
 "Premium payment related",
 "Claims",
 "Welcome kit",
 "Others"
];

const customerCategoryMap = {
 "Surrender": "surrender",
 "Payout related": "payout",
 "Issuance related": "issuance",
 "Refund cancellation": "refund_cancellation",
 "Customer info update": "customer_info_update",
 "Premium frequency change": "premium_frequency_change",
 "Premium payment related": "premium_payment",
 "Claims": "claims",
 "Welcome kit": "welcome_kit",
 "Others": "others"
};

/* ─ NRI categories ─ */
const nriCategories = ["GST",
  "Login process for EU and UK",
  "Login process",
  "UW guidelines for savings and protection",
  "TDS",
  "Std countries - investment plans",
  "NRI FAQs"];

const uwCategories = ['Savings', 'Protection', 'Protect and Gain (PnG)', 'Rider']

// Feedback comes after
const feedbackThreshold = {
  product: 2,
  nri: 2,
  lifeai: 2,
  uw: 2,
  customer: 2
}

const riderCategories = ["ADB/ATPD", "Booster", "Critical Illness"]

const categoryMapping = {
  GPP: 'Retirement',
  'Non-Linked Waiver of premium': 'Riders',
  'iPS Plus': 'Protection & Health',
  Signature: 'Market-linked',
  'GIFT Select': 'Guaranteed',
  'Assured Savings Insurance Plan': 'Guaranteed',
  GIFT: 'Guaranteed',
  'GIFT (Long-term)': 'Guaranteed',
  'GIFT Pro': 'Guaranteed',
  'Gold': 'Part-guaranteed',
  'Sukh Samruddhi': 'Part-guaranteed',
  'Savings Suraksha': 'Part-guaranteed',
  'Future Perfect': 'Part-guaranteed',
  'Platinum': 'Market-linked',
  'LifeTime classic': 'Market-linked',
  'Pru1Wealth': 'Market-linked',
  'Smart Goal Assure': 'Market-linked',
  'Signature Assure': 'Market-linked',
  'Protect N Gain Growth': 'Market-linked',
  'Protect N Gain Life': 'Protection with market-linked returns',
  'iPS ROP': 'Protection & Health',
  'iProtect Super': 'Protection & Health',
  'iProtect Supreme': 'Protection & Health',
  'iProtect Supreme ROP': 'Protection & Health',
  'Saral Jeevan Bima': 'Protection & Health',
  'WISH': 'Protection & Health',
  'GPP flexi': 'Retirement',
  'Saral pension': 'Retirement',
  'Signature pension': 'Retirement',
  'Gold pension savings': 'Retirement',
  'Non-Linked Accidental death and disability': 'Riders',
  'Linked Waiver of premium': 'Riders',
  'Linked Accidental death and disability': 'Riders',
  'Non-Linked Goal Protect': 'Riders'
};
const getCategoryForProduct = (prod) => categoryMapping[prod] || 'General';

const optionClickedPostProcessor = (e) => {
  console.log(e.target)
  Array.from(e.target.parentElement.children).forEach((children) => { children.style.border = '1px soild lightgray'; children.style.color = 'gray'; children.disabled = true });
  e.target.disabled = true;
  // UIupdate
  e.target.style.backgroundColor = '#C84E4E';
  // e.target.style.backgroundColor = '#7030a0';
  e.target.style.color = 'white'
}


  /* ─ tiny presentational bits ─ */
    const Bubble = ({ index, m, bot, selProd, messages, options, onOptionClick, categoryProducts, product_category_state, prodSession, handleOption, length_vec, posetiveFeedBackIndex, submitFeedbackPosetive, negativeFeedBackIndex, openFeedbackNegative }) => {
    const user = m.role === 'user';
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const assistantReplies = (messages || []).filter(
    msg =>
      msg.role === "assistant" &&
      msg.botType === m.botType &&
      !msg.options &&
      msg.text !== "..."
    ).length;
    
    return (
      <>
      <Box sx={{ mb: 2 }}>  
      <Box
      
              sx={{
      
                display: 'flex',
      
                justifyContent: user ? 'flex-end' : 'flex-start',
      
                width: '100%'
      
              }}
      >
      
              {!user && (
      <Avatar
      src={chatbotIcon}
      alt='Chatbot'
      sx={{
        // bgcolor: botMeta[m.botType]?.color || 'primary.main',
        mr: 1,
        width: 36,
        height: 36
      }}>
                  {/* {botMeta[m.botType]?.icon} */}
      </Avatar>
      
              )}
      
              {/* Wrapper for Bubble + Feedback */}
      <Box
      
                sx={{
      
                  display: 'flex',
      
                  flexDirection: 'column',
      
                  width: 'fit-content',
      
                  maxWidth: { xs: '85%', sm: '70%' }
      
                }}
      >
      <Paper
      
                  sx={{
      
                    overflowY: 'scroll',

                    mt:0,
      
                    p: 1.2,
      
                    borderRadius: 3,
                    
                    // UIupdate
                    bgcolor: user ? 'primary.main' : '#F7E9E5',
                    // bgcolor: user ? 'primary.main' : '#f7edff',
      
                    color: user
      
                      ? 'primary.contrastText'
      
                      : 'text.primary',
      
                    borderTopLeftRadius: user ? 30 : 0,
      
                    borderTopRightRadius: user ? 0 : 30,
      
                    '& a': {
      
                      color: user
      
                        ? 'inherit'
      
                        : 'primary.main'
      
                    }
      
                  }}
      >
      
                  {m.text == '...' && (
      <span remarkPlugins={[remarkGfm]}>
      
                      Typing ...
      </span>
      
                  )}
      
                  {m.text != '...' && (
      <span>
      
                      {bot != 'product' ? (
      <ReactMarkdown
      
                          components={{
      
                            a: ({ node, children }) => (
      <span>{children}</span>
      
                            )
      
                          }}
      >
      
                          {m.text}
      </ReactMarkdown>
      
                      ) : (
      <ReactMarkdown>
      
                          {m.text}
      </ReactMarkdown>
      
                      )}
      </span>
      
                  )}
      
                  {!user &&
                  options &&
                  options.length > 0 &&
                  !(m.botType === "product" && product_category_state === 1) && (
      <Box
                        sx={{
                          mt: 1.5,
                          display: 'flex',
                          flexWrap: 'wrap'
                        }}
      >
                        {options.map((o) => (
      <Button
                            key={o.text}
                            variant="outlined"
                            sx={{
                              mr: 1,
                              mb: 1,
                              borderRadius: 4,
                              fontSize: '10px',
                              textAlign: 'left'
                            }}
                            startIcon={o.icon}
                            onClick={(e) => {
                              onOptionClick(o.text);
                              optionClickedPostProcessor(e);
                            }}
      >
                            {o.text}
      </Button>
      
                        ))}
      </Box>
      
                    )}

                    {!user && m.showProductDropdown && categoryProducts.length > 0 && (
                      <Box sx={{ mt: 2,
                        width:{
                          xs: "100%",
                          sm: 300,
                          md: 350
                        }
                       }}>
                      <Autocomplete
                            options={categoryProducts}
                            value={selProd}
                            disabled={!!prodSession}
                            fullWidth
                            size="small"
                            onChange={(event, value) => {
                              if (value) {
                                handleOption(value);
                              }
                            }}
                            renderInput={(params) => (
                      <TextField
                                {...params}
                                label="Select Product"
                                placeholder="Choose a product"
                              />
                            )}
                          />
                      </Box>)
                    }
      
                  {!user && m.botType && (
      <Typography
      
                      sx={{
      
                        mt: 1,
      
                        display: 'block',
      
                        color: 'text.secondary',
      
                        fontSize: '0.7rem'
      
                      }}
      >
      
                      {/* {botMeta[m.botType].label} */}
      </Typography>
      
                  )}
      </Paper>
      
                {/* Feedback */}
      
                {!user &&
      
                  index === length_vec - 1 &&
      
                  assistantReplies >= (feedbackThreshold[bot] || 1) && (
      <Box
      
                      sx={{
      
                        display: 'flex',
      
                        justifyContent: 'flex-end',
      
                        gap: 1,
      
                        mt: 1.2,
      
                        width: '100%'
      
                      }}
      >
      
                      {/* Positive */}
      
                      {posetiveFeedBackIndex === index ? (
      <button
      
                          style={{
      
                            backgroundColor: '#C84E4E',
      
                            border: '2px solid #C84E4E',
      
                            borderRadius: '30%',
      
                            padding: '3px 7px',
      
                            cursor: 'pointer'
      
                          }}
      >
      <ThumbUpOffAltIcon
      
                            sx={{ color: '#fff' }}
      
                          />
      </button>
                      ) : (
      <button
                          style={{
                            backgroundColor: '#fff',
                            border: '2px solid #C84E4E',
                            borderRadius: '30%',
                            padding: '3px 7px',
                            cursor: 'pointer'
                          }}
                          onClick={() =>
                            submitFeedbackPosetive(index)
                          }
      >
      <ThumbUpOffAltIcon
                            sx={{ color: '#C84E4E' }}
                          />
      </button>
                      )}
                      {/* Negative */}
                      {negativeFeedBackIndex === index ? (
      <button
                          style={{
                            backgroundColor: '#C84E4E',
                            border: '2px solid #C84E4E',
                            borderRadius: '30%',
                            padding: '3px 7px',
                            cursor: 'pointer'
                          }}
      >
      <ThumbDownAltOutlined
                            sx={{ color: '#fff' }}
                          />
      </button>
                      ) : (
      <button
                          style={{
                            backgroundColor: '#fff',
                            border: '2px solid #C84E4E',
                            borderRadius: '30%',
                            padding: '3px 7px',
                            cursor: 'pointer'
                          }}
                          onClick={() =>
                            openFeedbackNegative(index)
                          }
      >
      <ThumbDownAltOutlined
                            sx={{ color: '#C84E4E' }}
                          />
      </button>
                      )}
      </Box>
                  )}
      </Box>
      </Box>
      </Box>
      </>
      );
  };
  /* ─────────────────────────────────────────────────────── */


export default function App2() {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const bottomPad = isMobile ? 72 : 0;
  const endRef = useRef(null);

  /* greet only once per session */
  const greeted = useRef(false);
  /* NEW – bump this number to force a fresh greeting */
  const [resetCount, setResetCount] = useState(0);
  /* ui */
  const [drawer, setDrawer] = useState(false);
  const [snack, setSnack] = useState({ open: false, msg: '', sev: 'info' });
  const [dialog, setDialog] = useState({ open: false, type: '' });

  /* chat */
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [typing, setTyping] = useState(false);
  /* active assistant */
  const [bot, setBot] = useState(null);

  /* product extras */
  const [prodSession, setProdSession] = useState('');
  const [selProd, setSelProd] = useState('');
  const [selCategory, setSelCategory] = useState('');
  const [categoryProducts, setCategoryProducts] = useState([]);
  const [prodDetails, setProdDetails] = useState(null);
  const [citations, setCitations] = useState([]);
  /* NRI extras */
  const [selNriCategory, setSelNriCategory] = useState('');
  const [selUwCategory, setSelUwCategory] = useState('');

  const [selUwRider, setSelUwRider] = useState('');


  /* the other IDs remain unchanged */
  const [nriSession, setNriSession] = useState('');  

  // Uw Notes:
  const [showUwNote, setShowUwNote] = useState(true);

  // const { setUserNTID, setUserChannel, userNTID } = useContext(UserContext);

  let [product_category_state, set_product_category_state] = useState(0)

  // const [lifeSession, setLifeSession] = useState(null);
  const [feedback_open, setFeedback_open] = useState(0)
  // const [lifeSessionRef, setLifeSessionRef] = useState('');
  // const [starterTokenRef, setStarterTokenRef] = useState('');
  const [introLoading, setIntroLoading] = useState(0)

  const [lifeToken] = useState(uuidv4());
  const [lifeSession, setLifeSession] = useState("");

  // Underwritter tokens 
  const [uwToken] = useState(uuidv4());
  const [uwSession, setUwSession] = useState('');
  
  // Customer Query Session
  const [customerSession, setCustomerSession] = useState("");
  const [selCustomerCategory, setSelCustomerCategory] = useState("");

  const navigate = useNavigate();
  const userNTID = localStorage.getItem('user_ntid')

  const pickSessionID = (d) => d.sessionid || d.sessionId || d.lifeSession || null;
  /* ─── utilities ─────────────────────────────────────── */
  const pushUser = t => setMessages(m => [...m, { role: 'user', text: t }]);
  const pushBot = (t, b = null, options = null) => setMessages(m => [...m, { role: 'assistant', text: t, botType: b, options }]);
  const notice = (msg, sev = 'info') => setSnack({ open: true, msg, sev });
  const FeedbackPopupClose = () => {
    setFeedback_open(0)
  }
  useEffect(() => {
    if (endRef.current) {
      endRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }
  }, [messages, categoryProducts, selProd, prodSession]);

  /* ─── GREETING (run once per reset) ─────────────────── */
  useEffect(() => {
    if (greeted.current) return;
    greeted.current = true;
    /* Welcome message with options data attached */
    setIntroLoading(1)
    getUsername().then((resp) => {
      setMessages([{
        role: 'assistant',
        text: "👋 Hi " + resp + ", Welcome to ICICI Prudential's Unified Assistant! How can I help you today?\n\nPlease choose one of the services below to get started:",
        botType: null,
        options: [
          { text: "Products", icon: <ViewInArOutlinedIcon /> },
          { text: "NRI Services", icon: <PublicIcon /> },
          { text: "Login & Claims Process", icon: <GroupsIcon /> },
          { text: "Underwriting", icon: <SecurityIcon /> },
          { text: "Customer Query", icon: <SupportAgentOutlinedIcon /> }
        ]
      }])
      setIntroLoading(0)

    }).catch((error) => {
      setMessages([{
        role: 'assistant',
        text: "👋 Hi User, Welcome to ICICI Prudential's Unified Assistant! How can I help you today?\n\nPlease choose one of the services below to get started:",
        botType: null,
        options: [
          { text: "Products", icon: <ViewInArOutlinedIcon /> },
          { text: "NRI Services", icon: <PublicIcon /> },
          { text: "Login & Claims Process", icon: <GroupsIcon /> },
          { text: "Underwriting", icon: <SecurityIcon /> },
          { text: "Customer Query", icon: <SupportAgentOutlinedIcon /> }
        ]
      }]);
      setIntroLoading(0)



    })
  }, [uwToken, resetCount]);
  const [posetiveFeedBackIndex, setPosetiveFeedBackIndex] = useState(-9999)
  const [negativeFeedBackIndex, setNegativeFeedBackIndex] = useState(-9999)
  // prevent back button leaving chat (keeps behaviour you had)
  // useEffect(() => {
  //   const handlePopState = () => window.history.pushState(null, "", window.location.href);
  //   window.history.pushState(null, "", window.location.href);
  //   window.addEventListener("popstate", handlePopState);
  //   return () => window.removeEventListener("popstate", handlePopState);
  // }, []);

  /* ─── OPTION handler ───────────────────────────────── */
  

  const handleOption = async txt => {
    // console.log("Calledddddd")
    pushUser(txt);
    setTyping(true);
    /* first-level selection */
    if (["Products", "NRI Services",
      "Login & Claims Process", "Underwriting", "Customer Query"].includes(txt)) {
      const map = {
        "Products": 'product',
        "NRI Services": 'nri',
        "Login & Claims Process": 'lifeai',
        "Underwriting": 'uw',
        "Customer Query": 'customer'
      };
      resetSelective()
      const chosen = map[txt];
      setBot(chosen);
      /* for product bot: list all products */
      // if (chosen === 'product') {

      //   let categories = ['Retirement', 'Riders', 'Protection & Health', 'Market-linked', 'Guaranteed', 'Part-guaranteed', 'Protection with market-linked returns']
      //   pushBot("Here are the categories we offer. Pick one:", 'product',
      //     categories.map(p => ({ text: p, icon: <ViewInArOutlinedIcon /> })));

      // }
      if (chosen === 'product') {
        try {
            const { data } = await apiClient.post(
                '/biu-chatbot/products',
                {
                    ntID: userNTID,
                    user_id: userNTID
                }
            );
            const products = data.products || [];
            setCategoryProducts(products);
            setMessages(prev => [
                ...prev,
                {
                  role: "assistant",
                  text: "Select a product from the list below.",
                  botType: "product",
                  showProductDropdown: true
                }
              ]);
        } catch (e) {
            pushBot("Failed to fetch products.", "product");
        }
      }
      /* for NRI bot: show category options */
      else if (chosen === 'nri') {
        pushBot("Please select a category for your NRI query:", 'nri',
          nriCategories.map(cat => ({ text: cat, icon: <PublicIcon /> })));
      }

      else if (chosen === 'uw') {
        setShowUwNote(true);  
        let categories = ['Savings', 'Protection', 'Protect and Gain (PnG)', 'Rider']
        pushBot("Please choose one of the following categories:", 'uw',
          categories.map(p => ({ text: p, icon: <SecurityIcon /> })));
      }
      else if (chosen === "customer") {
        pushBot(
          "Please choose one of the following categories:",
          "customer",
          customerCategories.map(cat => ({
            text: cat,
            icon: <SupportAgentOutlinedIcon />
          }))
        );
      }
      else {
        pushBot("Great — how can I assist you?", chosen);
      }
      setTyping(false);
      return;
    }

    /* product selection */
    if (bot === 'product' && !prodSession) {
      await startProd(txt);
      setTyping(false);
      return;
    }

    // Customer Query Bot Selection
    if (
      bot === "customer" &&
      !selCustomerCategory &&
      customerCategories.includes(txt)
    ) {
      setSelCustomerCategory(txt);
      pushBot(
        `You've selected **${txt}**. How can I help you?`,
        "customer"
      );
      setTyping(false);
      return;
    }

    /* NRI category selection */
    if (bot === 'nri' && !selNriCategory && nriCategories.includes(txt)) {
      setSelNriCategory(txt);
      pushBot(`You've selected the **${txt}** category. How can I help you?`, 'nri');
      setTyping(false); return;
    }
    // if (bot === 'uw' && !selUwCategory && uwCategories.includes(txt)) {
    //   setSelUwCategory(txt);
    //   pushBot(`You've selected the **${txt}** category. How can I help you?`, 'uw');
    //   setTyping(false); return;
    // }
    if (bot === 'uw' && !selUwCategory && uwCategories.includes(txt)) {
    if (txt === "Rider") {
      setSelUwCategory("Rider");
      pushBot(
        "Please choose one of the rider options:",
        "uw",
        riderCategories.map(r => ({
          text: r,
          icon: <ViewInArOutlinedIcon />
        }))
      );
      setTyping(false);
      return;
    }
    setSelUwCategory(txt);
    pushBot(
      `You've selected the **${txt}** category. How can I help you?`,
      "uw"
    );
    setTyping(false);
    return;
    }

    if (
        bot === "uw" &&
        selUwCategory === "Rider" &&
        !selUwRider &&
        riderCategories.includes(txt)
      ) {
        setSelUwRider(txt);
        pushBot(
          `You've selected **${txt}**. How can I help you?`,"uw"
        );
        setTyping(false);
        return;
      }
      await handleSend(txt, false);
    };

  const Logout = ()=>{
    localStorage.clear()
    navigate('/');

  }

  /* ─── product helpers ───────────────────────────────── */
  const startProd = async p => {
    try {
      // const {data}=await axios.post('http://localhost:8000/product-chatbot/chatbot/session',{product:p});
      const { data } = await apiClient.post('/biu-chatbot/session', { ntID: userNTID, user_id: userNTID, product: p });
      setProdSession(data.session_id);
      setSelProd(p);
      // setCategoryProducts([]);
      await loadProdDetails(p);
      // let questions = []
      // if (Object.keys(product_questionaire).includes(p)) {
      //   questions = product_questionaire[p].map((i) => { return { text: i, icon: <ArrowForwardIcon /> } })
      // }
      const questions = product_default_q.questions.map((i) => ({
        text: i,
        icon: <ArrowForwardIcon />
      }));
 
      pushBot(`You've selected **${p}**. What would you like to know?`, 'product', questions);
    } catch (e) { console.error(e); pushBot("Sorry — It's not you, its us. Please try again after sometime.", "product"); }
  };
  const loadProdDetails = async p => {
    try {
      const map = chatbotMapping.find(i => i.ChatbotProductName === p);
      if (!map) return;
      const front = productFrontend.find(f => f.product_json_ID === String(map.product_json_ID));
      if (!front) return;
      // const {data}=await axios.get(`http://localhost:8000/product-chatbot/chatbot/productAemDetails?url=${encodeURIComponent(front.PRODUCT_DETAILS_AEM_URL)}`);
      const { data } = await apiClient.post(`/product-chatbot/chatbot/productAemDetails?url=${encodeURIComponent(front.PRODUCT_DETAILS_AEM_URL)}`, { ntID: userNTID, user_id: userNTID });
      setProdDetails({ ...data });
    } catch (e) { console.error(e); }
  };
  // const askProd = async q => {
  //   // let categories = ['Retirement', 'Riders', 'Protection & Health', 'Market-linked', 'Guaranteed', 'Part-guaranteed', 'Protection with market-linked returns']
  //   if (!prodSession) {
  //     if (selCategory && categoryProducts.length) {
  //       pushBot("Please pick a product first.", 'product',
  //         categoryProducts.map(p => ({ text: p, icon: <ViewInArOutlinedIcon /> })));
  //         setTyping(false);
  //         return;
  //     }
  //     let categories = ['Retirement', 'Riders', 'Protection & Health', 'Market-linked', 'Guaranteed', 'Part-guaranteed', 'Protection with market-linked returns']
  //      pushBot("Please pick a category first.", 'product',
  //        categories.map(p => ({ text: p, icon: <ViewInArOutlinedIcon /> })));
  //      setTyping(false);
  //      return;
  //     }
  //     try {
  //       const { data } = await apiClient.post('/biu-chatbot/message', { ntID: userNTID, user_id: userNTID, session_id: prodSession, query: q });
  //       setCitations(data.citations || []);
  //       if (data.citations.length == 0) {
  //         return "I don't have appropriate infromations about this query. Please ask a different question or select a different bot.";
  //       }
  //       return data.answer;
  //     } catch (e) {
  //       console.error(e);
  //       return "Sorry — It's not you, its us. Please try again after sometime.";
  //     }
  //   };
  const askProd = async q => {
  // Product/category validation
  if (!prodSession) {
    if (selCategory && categoryProducts.length) {
      pushBot(
        "Please pick a product first.",
        'product',
        categoryProducts.map(p => ({
          text: p,
          icon: <ViewInArOutlinedIcon />
        }))
      );
      setTyping(false);
      return null;
    }
    let categories = [
      'Retirement',
      'Riders',
      'Protection & Health',
      'Market-linked',
      'Guaranteed',
      'Part-guaranteed',
      'Protection with market-linked returns'
    ];
    pushBot(
      "Please pick a category first.",
      'product',
      categories.map(p => ({
        text: p,
        icon: <ViewInArOutlinedIcon />
      }))
    );
    setTyping(false);
    return null;
  }
  try {
    const { data } = await apiClient.post(
      '/biu-chatbot/message',
      {
        ntID: userNTID,
        user_id: userNTID,
        session_id: prodSession,
        query: q
      }
    );
    console.log("Product Response:", data);
    setCitations(data.citations || []);
    if ((data.citations || []).length === 0) {
      return {
        answer:
          "I don't have appropriate informations about this query. Please ask a different question or select a different bot.",
        options: []
      };
    }
    /*
     * Convert backend related_questions
     * into the SAME options structure
     * already used by product_default_q.
     */
    let relatedQuestions = [];
    if (Array.isArray(data.related_questions)) {
      relatedQuestions = data.related_questions;
    } else if (typeof data.related_questions === 'string') {
      relatedQuestions =
        data.related_questions
          .match(/```([\s\S]*?)```/g)
          ?.map(q => q.replace(/```/g, '').trim())
          .filter(Boolean) || [];
    }
    const questionOptions = relatedQuestions.map(question => ({
      text: question,
      icon: <ArrowForwardIcon />
    }));
    console.log("Related Question Options:", questionOptions);
    return {
      answer: data.answer,
      options: questionOptions
    };
  } catch (e) {
    console.error(e);
    return {
      answer:
        "Sorry — It's not you, its us. Please try again after sometime.",
      options: []
    };
  }
};
  /* ─── ask wrappers for other bots ───────────────────── */
  // const askNri = async q => {
  //   try {
  //     // const { data } = await axios.post('http://localhost:8000/nri-chatbot/nri-chatbot/chat/query', {
  //     const { data } = await apiClient.post('/biu-chatbot/chat/query', {
  //       query: q,
  //       category: selNriCategory || 'GST',
  //       session_id: '',
  //       response_type: 'default',
  //       ntID: userNTID,
  //     });
  //     setCitations(data.citations || []);
  //     if(data.citations.length == 0){
  //       return "I don't have appropriate infromations about this query. Please ask a different question or select a different bot."
  //     }        
  //     return data.answer;
  //   } catch (e) {
  //     console.error(e);
  //     return "Sorry — It's not you, its us. Please try again after sometime.";
  //   }
  // };
  const askNri = async (q) => {
    try {
      const nriPayload = {
        query: q,
        category: selNriCategory || "GST",
        response_type: "default",
        ntID: userNTID,
        user_id: userNTID,
        session_id: nriSession
      };
      console.log("NRI Payload:", nriPayload);
      const { data } = await apiClient.post(
        "/biu-chatbot/chat/query",
        nriPayload
      );
      console.log("NRI Response:", data);
      if (data.session_id) {
        setNriSession(data.session_id);
      }
      setCitations(data.citations || []);
      if (data.citations.length === 0) {
        return "I don't have appropriate informations about this query. Please ask a different question or select a different bot.";
      }
      return data.answer;
    } catch (e) {
      console.error(e);
      return "Sorry — It's not you, its us. Please try again after sometime.";
    }
  };

  // const buildLifePayload = (q) => {
  //   const base = { question: q, ntID: userNTID };
  //   return lifeSessionRef
  //     ? { ...base, token: lifeSessionRef }
  //     : { ...base, token: starterTokenRef };
  // };

  // const askLife = async q => {
  //   const body = buildLifePayload(q);
  //   const { data } = await apiClient.post('/biu-chatbot/life-chatbot/chat2', body);
  //   console.log("here...", data)
  //   setCitations(data.citations || []);

  //   const sid = pickSessionID(data);
  //   if (sid !== lifeSessionRef) {
  //     setLifeSessionRef(String(sid));
  //     setStarterTokenRef(String(sid));
  //   }
  //   if(data.citations.length == 0){
  //     return "I don't have appropriate infromations about this query. Please ask a different question or select a different bot."
  //   }        

  //   return data.answer.replace(/\[([^\]]+)\]\([^)]*\)/g,'[$1]');
  // };

  const askLife = async (q) => {
    try {
      const lifePayload = {
        token: lifeToken,
        sessionid: lifeSession,
        question: q,
        ntID: userNTID,
        user_id: userNTID
      };
      console.log("Life Payload:", lifePayload);
      const { data } = await apiClient.post(
        "/biu-chatbot/life-chatbot/chat2",
        lifePayload
      );
      console.log("Life Response:", data);
      if (data.sessionid) {
        setLifeSession(data.sessionid);
      }
      setCitations(data.citations || []);
      if ((data.citations || []).length === 0) {
        return "I don't have appropriate informations about this query. Please ask a different question or select a different bot.";
      }
      return data.answer.replace(/\[([^\]]+)\([^)]*\)/g, "[$1]");
      
    } catch (e) {
      console.error(e);
      return "Sorry — It's not you, its us. Please try again after sometime.";
    }
  };

  // askCustomer Function
  const askCustomer = async (q) => {
    const categoryName = customerCategoryMap[selCustomerCategory] || "others";
    try {
      const customerPayload = {
        sessionid: customerSession,
        question: q,
        user_id: userNTID,
        categoryName
      };
      console.log("Customer Payload:", customerPayload);

      const { data } = await apiClient.post(
        "/biu-chatbot/customerservice",
        customerPayload
      );
      console.log("Customer Response:", data);
      if (data.sessionid) {
        setCustomerSession(data.sessionid);
      }
      setCitations(data.citations || []);
      if ((data.citations || []).length === 0) {
        return "I don't have appropriate informations about this query. Please ask a different question or select a different bot.";
      }
      return data.answer.replace(/\[([^\]]+)\([^)]*\)/g, "[$1]");
    } catch (e) {
      console.error(e);
      return "Sorry — It's not you, its us. Please try again after sometime.";
    }
  };


  // const askUw = async (q, category) => {
  //   try {
  //     const { data } = await apiClient.post("/biu-chatbot/underwriter-chatbot/chat_uw",
  //       { token: uwToken, question: q, ntID: userNTID, productName: category});
  //       setUwSession(data.sessionid);
  //       setCitations(data.citations || []);
  //       if(data.citations.length == 0){
  //         return "I don't have appropriate infromations about this query. Please ask a different question or select a different bot."
  //       }        
  //       return data.answer;
  //   } catch (e) { console.error(e); return "Sorry UW— It's not you, its us. Please try again after sometime."; }
  // };

  // askUW() updated - sending sessionid from the response
  const askUw = async (q, category) => {
    try {
      const uwPayload = {
        token: uwToken,
        sessionid: uwSession,
        question: q,
        ntID: userNTID,
        user_id: userNTID,
        productName: category
      };
      console.log("UW Payload:", uwPayload);
      const { data } = await apiClient.post(
        "/biu-chatbot/underwriter-chatbot/chat_uw",
        uwPayload
      );
      console.log("UW Response:", data);
      // Store the session id returned by backend for future requests
      if (data.sessionid) {
        setUwSession(data.sessionid);
      }
      setCitations(data.citations || []);
      if (data.citations.length === 0) {
        return "I don't have appropriate informations about this query. Please ask a different question or select a different bot.";
      }
      return data.answer;
    } catch (e) {
      console.error(e);
      return "Sorry UW- It's not you, its us. Please try again after sometime.";
    }
  };

  /* ─── reset routine (for restart) ───────────────────── */

  const resetSelective = () => {
    setTyping(false);
    setBot(null);
    
    setProdSession('');
    setSelProd('');
    setProdDetails(null);
    setCitations([]);
    setSelCategory('');
    setCategoryProducts([]);
    
    setSelNriCategory('');
    setNriSession('');
    
    setSelUwCategory('');
    setSelUwRider('');
    setUwSession('');

    setCustomerSession('');
    setSelCustomerCategory('');

    setLifeSession('');
  }

  const getUsername = async () => {
    try{
    const { data } = await apiClient.post('/biu-chatbot/generic/getuserfullname', { user_id: userNTID, ntID: userNTID });
    console.log(data)
    return data.username
  }catch(e){
    console.log(e)
    // Logout()
  }
  }

  const resetAll = async () => {
    /* clear all state */
    setMessages([]);
    setInput('');
    setTyping(false);
    setBot(null);
    setProdSession(''); setSelProd(''); setProdDetails(null); setCitations([]);
    setSelCategory(''); setCategoryProducts([]);
    setSelNriCategory('');

    // Reset UW session
    setUwSession('');
    setSelUwCategory('');

    setLifeSession('');

    setNriSession('');

    setSelUwRider('');

    setCustomerSession('');
    setSelCustomerCategory('');

    greeted.current = false;            // allow greeting again
    setResetCount(c => c + 1);            // trigger the greeting effect
    set_product_category_state(0)
    setPosetiveFeedBackIndex(-9999)
    setNegativeFeedBackIndex(-9999)
  };

  /* ─── main send (free-text) ─────────────────────────── */
  const handleSend = async (q = input, show_message = true) => {
    if (!q.trim()) return;
    if (show_message) {
      pushUser(q);
    }
    setInput(''); setTyping(true);
    let ans = '';
    switch (bot) {
      case 'product':
        ans = await askProd(q);
        if(!ans) { 
          setTyping(false); 
          return;}
        break;
      case "customer":
        if (!selCustomerCategory) {
          pushBot(
            "Please select a category first.",
            "customer",
            customerCategories.map(cat => ({
              text: cat,
              icon: <SupportAgentOutlinedIcon />
            }))
          );
          setTyping(false);
          return;
        }
        ans = await askCustomer(q);
      break;

      case 'nri':
        if (!selNriCategory) {
          pushBot("Please select a category first:", 'nri',
            nriCategories.map(cat => ({ text: cat, icon: <PublicIcon /> })));
          setTyping(false);
          return;
        }
        ans = await askNri(q);
        break;
      case 'lifeai': ans = await askLife(q); break;

      case 'uw':
        if (!selUwCategory) {
          pushBot(
            "Please select a category first:",
            'uw',
            uwCategories.map(cat => ({
              text: cat,
              icon: <SecurityIcon />
            }))
          );
          setTyping(false);
          return;
        }
        const categoryMap = {
          Savings: 'savings',
          Protection: 'protection',
          'Protect and Gain (PnG)': 'png',
          'ADB/ATPD': 'ADB_ATPD',
          Booster: 'Booster',
          'Critical Illness': 'CI'
        };
        const category = selUwCategory === 'Rider' ? categoryMap[selUwRider] : categoryMap[selUwCategory];

        console.log("selUwCategory:", selUwCategory);
        console.log("selUwRider:", selUwRider);
        console.log("category:", category);
        
        ans = await askUw(q, category);
      break;

      default:
        pushBot("Please select a service first.", null, [
          { text: "Products", icon: <ViewInArOutlinedIcon /> },
          { text: "NRI Services", icon: <PublicIcon /> },
          { text: "Login & Claims Process", icon: <GroupsIcon /> },
          { text: "Underwriting", icon: <SecurityIcon /> },
          { text: "Customer Query", icon: <SupportAgentOutlinedIcon /> }
        ]);
        setTyping(false); return;
    }
    // pushBot(ans, bot); setTyping(false);
    if (bot === 'product' && ans && typeof ans === 'object') {
      pushBot(
      ans.answer,
      bot,
      ans.options || []);
    } else {
        pushBot(ans, bot);
      }
      setTyping(false);
  };

  const sanitizeText = (value) => {
    if (!value) return '';
    return String(value)
      .replace(/[^a-zA-Z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  };
  
  const sanitizeChatMessages = (messages) => {
    return sanitizeText(JSON.stringify(messages));
  };
  
  const submitFeedbackNegative = async () => {
  
    const sanitizedMessages = sanitizeChatMessages(messages);

    const currentSession =
      bot === "product"
        ? prodSession
        : bot === "lifeai"
        ? lifeSession
        : bot === "uw"
        ? uwSession
        : bot === "nri"
        ? nriSession
        : customerSession;
  
    await apiClient.post('/biu-chatbot/generic/feedback', {
      session_id: currentSession, // not sanitized
      ntID: userNTID, // not sanitized
      user_id: userNTID,
      query: sanitizeText('str'),
      response: sanitizeText(
        document.getElementById('feedback_negative_value')?.value
      ),
      feedback: 'thumbs_down', // not sanitized
      product: sanitizeText(bot),
      chat_messages: sanitizedMessages
    });
    setFeedback_open(0);
  };
  
  const submitFeedbackPosetive = async (index) => {
    if (
      index === posetiveFeedBackIndex ||
      index === negativeFeedBackIndex
    ) {
      return;  
    }

    const sanitizedMessages = sanitizeChatMessages(messages);
  
    setPosetiveFeedBackIndex(index);

    const currentSessionMap = {
      product: prodSession,
      lifeai: lifeSession,
      uw: uwSession,
      nri: nriSession,
      customer: customerSession
    };
    
    const currentSession = currentSessionMap[bot] || "";
  
    await apiClient.post('/biu-chatbot/generic/feedback', {
      session_id: currentSession, // not sanitized
      ntID: userNTID, // not sanitized
      user_id: userNTID,
      query: sanitizeText('str'),
      response: '',
      feedback: 'thumbs_up', // not sanitized
      product: sanitizeText(bot),
      chat_messages: sanitizedMessages
    });
  };  
 
  // const submitFeedbackNegative = async () => {
  //   const sanitizedMessages = sanitizeChatMessages(messages);

  //   await apiClient.post('/biu-chatbot/generic/feedback', { session_id: bot,ntID:userNTID, query: 'str', response: document.getElementById('feedback_negative_value').value, feedback: 'thumbs_down', product: bot, chat_messages: sanitizedMessages })
  //   setFeedback_open(0)
  // }
  // const submitFeedbackPosetive = async (index) => {
  //   const sanitizedMessages = sanitizeChatMessages(messages);

  //   if(index == posetiveFeedBackIndex || index == negativeFeedBackIndex){
  //     return 
  //   }
  //   setPosetiveFeedBackIndex(index)
  //   await apiClient.post('/biu-chatbot/generic/feedback', { session_id: bot,ntID:userNTID, query: 'str', response: '', feedback: 'thumbs_up', product: bot, chat_messages: sanitizedMessages })
  // }
  
  const openFeedbackNegative = (index) => {
    if(index == posetiveFeedBackIndex || index == negativeFeedBackIndex){
      return 
    }

    setNegativeFeedBackIndex(index)
    setFeedback_open(1)
  }

  /* ─── feedback send (product) ───────────────────────── */
  const prodFeedback = async kind => {
    try {
      const lastUser = [...messages].reverse().find(m => m.role === 'user');
      const lastBot = [...messages].reverse().find(m => m.role === 'assistant' && m.botType === 'product');
      if (!lastUser || !lastBot) return;
      // await axios.post('http://localhost:8000/product-chatbot/chatbot/feedback',{
      await apiClient.post('http://localhost:8000/product-chatbot/chatbot/feedback', {
        session_id: prodSession, query: lastUser.text, response: lastBot.text,
        feedback: kind, product: selProd, ntID: userNTID, user_id: userNTID
      });
      notice('Thanks for the feedback!', 'success');
    } catch (e) { console.error(e); notice('Failed to send feedback', 'error'); }
  };
  /* ─── Dialog body ───────────────────────────────────── */
  const dialogBody = () => {
    if (dialog.type === 'attachments')
      return (
        <>
          <DialogTitle>Product attachments</DialogTitle>
          <DialogContent dividers>
            {prodDetails ?
              ['brochure', 'product_ppt', 'one_pager', 'terms_and_conditions'].map(k =>
                prodDetails[k] && (
                  <ListItem key={k} component="a" href={prodDetails[k]} target="_blank" button>
                    <ListItemIcon><AttachFileIcon /></ListItemIcon>
                    <ListItemText primary={k.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())} />
                  </ListItem>
                )
              ) : <Typography>No attachments.</Typography>}
          </DialogContent>
        </>
      );
    if (dialog.type === 'citations')
      return (
        <>
          <DialogTitle>Sources & citations</DialogTitle>
          <DialogContent dividers>
            {citations.map((c, i) => (
              <Typography key={i} variant="body2" sx={{ mb: 2, p: 2, backgroundColor: theme.palette.grey[50], borderRadius: 1 }}>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>{c.trim('#')}</ReactMarkdown>
              </Typography>
            ))}
          </DialogContent>
        </>
      );
    if (dialog.type === 'feedback')
      return (
        <>
          <DialogTitle>Rate my last response</DialogTitle>
          <DialogContent dividers>
            <Box sx={{ display: 'flex', justifyContent: 'space-around', mt: 1 }}>
              <Button variant="outlined" startIcon={<ThumbUpOffAltIcon />}
                onClick={() => { prodFeedback('positive'); setDialog({ open: false }); }}>
                Helpful
              </Button>
              <Button variant="outlined" color="error" startIcon={<ThumbDownIcon />}
                onClick={() => { prodFeedback('negative'); setDialog({ open: false }); }}>
                Not helpful
              </Button>
            </Box>
          </DialogContent>
        </>
      );
    return null;
  };
  /* ─── render ───────────────────────────────────────── */
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline /><GlobalStyles />
      <div style={{ position: 'fixed', height: '220px', width: '220px', 'left': '0px', 'top': '250px', backgroundColor: 'black', color: 'white', zIndex: 9999, fontSize: '8px', display: 'none' }}>

        <table>
          <thead>
            <tr><th>Name</th><th>Value</th></tr>
          </thead>
          <tbody>
            <tr><td>Selected Bot</td><td>{bot}</td></tr>
            <tr><td>lifeSession</td><td>{lifeSession}</td></tr>
          </tbody>
        </table>
 
      </div>
      {/* — AppBar — */}
      <AppBar color="white" position="fixed" sx={{ zIndex: 1, background: '#ffffff' }}>
        <Toolbar>
          <Box
            component="img"
            src={livaLogo}
            alt="LIVA Logo"
            // sx={{ height: 32 }}
            sx={{ height: 52, marginLeft:-2 }}
          />

          <Typography variant="h4" sx={{ flexGrow: 1 }}>
          </Typography>
          {/* Restart */}
          <Tooltip title="Restart chat">
            <Typography variant="h12" sx={{ flexGrow: 1 }}>Restart</Typography>
            <IconButton color="inherit" onClick={resetAll}><ReplayIcon /></IconButton>
          </Tooltip>
          {/* <Tooltip title="Notifications">
            <IconButton color="inherit">
              <Badge badgeContent={0} color="secondary"><NotificationsIcon /></Badge>
            </IconButton>
          </Tooltip> */}
          {bot === 'product' && (
            <>
              {prodDetails && (
                <Tooltip title="Attachments">
                  <IconButton color="inherit" onClick={() => setDialog({ open: true, type: 'attachments' })}>
                    <AttachFileIcon />
                  </IconButton>
                </Tooltip>
              )}
            </>
          )}
              {citations.length > 0 && (
                <Tooltip title="Citations">
                  <IconButton color="inherit" onClick={() => setDialog({ open: true, type: 'citations' })}>
                    <MenuBookIcon />
                  </IconButton>
                </Tooltip>
              )}
          {/* <Button variant='outlined' onClick={Logout}>Logout</Button> */}

        </Toolbar>
      </AppBar>
      {/* — Drawer — */}
      {/* <Drawer anchor="left" open={drawer} onClose={() => setDrawer(false)}>

        <Box sx={{ width: 280 }}>
          <Box sx={{ p: 2, display: 'flex', alignItems: 'center' }}>
            <ViewInArOutlinedIcon color="primary" sx={{ mr: 1 }} /><Typography variant="h6">ICICI Prudential</Typography>
          </Box>
          {JSON.stringify(botMeta)}
          <List>
            {Object.keys(botMeta).map(id => (
              <ListItem key={id}>
                <ListItemButton selected={bot === id}
                  onClick={() => { setBot(id); pushBot("How can I help you?", id); setDrawer(false); }}>
                  <ListItemIcon>{botMeta[id].icon}</ListItemIcon>
                  <ListItemText primary={botMeta[id].label}/>
                </ListItemButton>
              </ListItem>
            ))}
            <ListItem>
              <ListItemButton onClick={() => { resetAll(); setDrawer(false); }}>
                <ListItemIcon><ReplayIcon /></ListItemIcon>
                <ListItemText primary="Restart chat" />
                <ListItemText>
                </ListItemText>
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </Drawer> */}
      {/* — Chat pane — */}
      <Box sx={{ pt: { xs: 7, sm: 8 }, background: '#fff', pb: bottomPad, height: '100vh', display: 'flex', flexDirection: 'column' }}>
        {/* Main scrollable chat area */}
        <Modal
          open={feedback_open}
          onClose={() => { setFeedback_open(0); setNegativeFeedBackIndex(-9999) }}
        >
          <div style={{ margin: '250px' }}>
            <div style={{ padding: '20px', backgroundColor: 'white', overflowY: 'scroll', height: '250px', width: '100%', marginLeft: '0' }}>
              <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                <h4>Please provide your feedback and opinion. </h4>
              </Typography>
              <TextField minRows={3} sx={{ width: '100%', 'marginBottom': '5' }} placeholder='Tell us your feedback' id="feedback_negative_value" />

              <Button variant="contained" color="primary" sx={{ float: 'right', marginTop: '15px' }} onClick={submitFeedbackNegative}>Submit</Button>
              <Button variant="outlined" color="primary" sx={{ float: 'right', marginTop: '15px', marginRight: '15px' }} onClick={FeedbackPopupClose}>Close</Button>


            </div>
          </div>

        </Modal>
        <Box
          sx={{ 
            height: '100vh', // Forces the whole chat window to match screen height
            display: 'flex', 
            flexDirection: 'column' 
          }}>
        <Box sx={{ flexGrow: 1, overflowY: 'auto', maxHeight:'100%', px: { xs: 1, sm: 2 }, pb: 2, pt: 10, mb:10 }}>
          {introLoading ? (<center sx={{ fontSize: '27px', color: 'gray' }}>Initializing session. Please wait ...</center>) : (<></>)}
          {messages.map((m, i) => <Bubble key={i} selProd={selProd} messages={messages} categoryProducts={categoryProducts} product_category_state={product_category_state} prodSession={prodSession} 
          handleOption={handleOption} bot={bot} index={i} m={m} options={m.options} onOptionClick={handleOption} length_vec={messages.length} posetiveFeedBackIndex={posetiveFeedBackIndex} 
          submitFeedbackPosetive={submitFeedbackPosetive} negativeFeedBackIndex={negativeFeedBackIndex} openFeedbackNegative={openFeedbackNegative}  />)}
          {typing && <Bubble messages={messages} bot={bot} m={{ role: 'assistant', text: '...', botType: bot }} length_vec={messages.length} />}
          <div ref={endRef} />
          <br /><br />
        </Box></Box>
        {/* Fixed bottom section with input */}
        <Box sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          bgcolor: 'background.paper',
          borderTop: '1px solid',
          borderColor: 'divider',
          zIndex: 10
        }}>
          <Box sx={{ px: { xs: 1, sm: 2 }, py: 1 }}>
                {/* {bot=='uw' ?(<>

            <div style={{ fontSize: '14px', backgroundColor: '#ffc800', padding: '5px', border: '1px solid #ff6a00', borderRadius: '6px' }}>
              <b>Note on Underwriter bot:</b><br/>
            Answers are based on the latest UW Manual for sales. Please note that the answers may not reflect any interim changes or policy updates done after the manual's last publication date
            While the answers align with the UW manual, all the final decisions remain at the discretion of the underwriter for all cases.
            </div>            <br/>

            </>) : (<></>)} */}

            {bot === 'uw' && showUwNote ? (
            <div
                style={{
                  position: 'relative',
                  fontSize: '14px',
                  backgroundColor: '#ffc800',
                  padding: '5px',
                  border: '1px solid #ff6a00',
                  borderRadius: '6px',
                  marginBottom: '9px'
                }}
            >
            <IconButton
              size="small"
              onClick={() => setShowUwNote(false)}
              sx={{
                position: 'absolute',
                top: 0,
                right: 0
              }}
            >
            <CloseIcon fontSize="small" />
            </IconButton>
            <b>Note on Underwriter bot:</b>
            <br />
            Answers are based on the latest UW Manual for sales. Please note that the answers may not reflect any interim changes or policy updates done after the manual's last publication date. While the answers align with the UW manual, all the final decisions remain at the discretion of the underwriter for all cases.
            </div>
            ) : null}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <TextField
                fullWidth
                size="small"
                placeholder="Type your message..."
                value={input}
                onChange={e => setInput(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSend(); } }}
              />
              <IconButton disabled={!input.trim()} onClick={() => handleSend()}>
                {/* UIupdate */}
                {/* <SendIcon sx={{ color: "rgb(112 48 160)" }} /> */}
                <SendIcon sx={{ color: "#C84E4E" }} />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </Box>
      {/* — Dialog — */}
      <Dialog open={dialog.open} onClose={() => setDialog({ open: false })} maxWidth="sm" fullWidth>
        {dialogBody()}
        <DialogActions>
          <Button onClick={() => setDialog({ open: false })} startIcon={<CloseIcon />}>Close</Button>
        </DialogActions>
      </Dialog>
      {/* — Snackbar — */}
      <Snackbar open={snack.open} autoHideDuration={4000} onClose={() => setSnack({ ...snack, open: false })}>
        <Alert severity={snack.sev} onClose={() => setSnack({ ...snack, open: false })}>{snack.msg}</Alert>
      </Snackbar>
    </ThemeProvider>
  );
}